import { useMemo, useState } from 'react';
import ProjectRole, { VALID_ASSIGNABLE_ROLES } from '@projectMembers/models/projectRole';

const useRoleSelectorState = ( { currentUserRole }: { currentUserRole: ProjectRole } ) => {
	const roleOptions = VALID_ASSIGNABLE_ROLES.map( role => ( {
		role,
		disabled: !currentUserRole.canInviteRole( role ),
		additionalInfo: !currentUserRole.canInviteRole( role ) ? 'Only Managers' : undefined
	} ) );
	const defaultRole = useMemo(
		() => ProjectRole.projectEditor(),
		[ roleOptions ]
	);

	const [ selectedRole, setSelectedRole ] = useState<ProjectRole>( defaultRole );

	return {
		selectedRole,
		roleOptions,
		onRoleChange: setSelectedRole
	};
};

export default useRoleSelectorState;
